import { createI18n } from 'vue-i18n'
import en from '@/lib/i18n/locales/en'

/**
 * vue-i18n scaffold. Single-source-of-truth for user-facing text
 * lives under `locales/<lang>.ts`. Today only `en` is wired; adding
 * a locale is a two-step:
 *   1. Drop `locales/<lang>.ts` exporting the same shape as `en`
 *   2. Register it in the `messages` map below
 *
 * Locale selection: defaults to `en`. Future per-tenant or per-user
 * locale override flows through `globalStore.locale`.
 *
 * Usage in templates:
 *   {{ $t('auth.login.submit') }}
 *
 * Usage in setup:
 *   const { t } = useI18n()
 *   t('auth.login.submit')
 *
 * Strict mode (`legacy: false`) — Composition API only. Matches the
 * rest of the app's setup-script convention.
 */
export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
  },
})

export type AppLocale = keyof typeof i18n.global.messages.value
